<template>
  <div>
    <div class="columns">
      <div class="column is-9">
        <b-field v-if="options">
          <b-input v-model="searchName" icon="search" placeholder="Search seasons in this hotel"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <a class="button full-width-button  is-primary" @click="openModal">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
            <span>Add</span>
          </a>
      </div>
      
         <!--    <div class="has-text-centered">
        <div v-if="!option.length">
        <img :src="'/static/nodata.gif'" alt="No data Found" style="height : 200pt">            
        <div class="subtitle">No Rooms Found!</div> <hr v-if="!option">
        </div>
        </div>  -->
    </div>
    <div class="has-text-centered" >
      <img :src="'/static/nodata.gif'" v-if="!options.length"  alt="No data Found" style="height : 200pt"> 
      <p class="subtitle" v-if="!options.length">Seasons not found in {{city.name}}</p>
      <hr v-if="!options.length">
      </div> 
    <div class="columns is-multiline">
      <div class="column is-4" v-for="option in filterBy(options, searchName)" :key="option.docId">
        <div class="card">
          <div class="card-content">
         <span class="icon is-small">
            <i class="fas fa-snowflake"></i>
          </span>
          <span><strong>     &nbsp; {{option.label | truncate(40)}}</strong></span> <br>
           
       <p title="Season Start Date"> <i class="fas fa-calendar-alt" ></i> &nbsp;  {{moment(option.startDate).format('Do MMMM YYYY')}}</p> 
       <p title="Season End Date">  <i class="far fa-calendar-alt" ></i> &nbsp;  {{moment(option.endDate).format("Do MMMM YYYY")}}</p>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item" @click="openModal(option)">Edit</a>
            <a class="card-footer-item" @click="deleteOption(option)">Delete</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ManageSeasons from './ManageSeasons';
import DeliveryOptionsService from './service';
import UploadService from '../../../lib/UploadService';

export default {
  name: 'seasons',

  props: ['city'],

  created() {
    this.fetchDeliveryOptions();
    this.$bus.$on('CITY_CHANGED', city => {
      // this.city = city;
      this.fetchDeliveryOptions();
    });
  },

  data() {
    return {
      isLoading: true,
      searchName: null,
      options: null,
      files: null
    };
  },

  methods: {
    fetchDeliveryOptions() {
      DeliveryOptionsService.all(this.city).then(data => {
        this.options = data;
        this.isLoading = false;

      });
      
    },

    deleteOption(optionToBeDeleted) {
      this.$dialog.confirm({
        message: 'Sure to delete delivery option?',
        onConfirm: () => {
          this.isLoading = true;

          DeliveryOptionsService.deleteOption(
            this.city,
            optionToBeDeleted
          ).then(() => {
            this.options = this.options.filter(
              option => option.docId !== optionToBeDeleted.docId
            );
            this.isLoading = false;
            this.$toast.open('Season deleted successfully');
          });
        }
      });
    },

    openModal(option = null) {
      this.$modal.open({
        parent: this,
        props: {
          option,
          city: this.city
        },
        component: ManageSeasons,
        hasModalCard: true
      });
    },


  }
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/Seasons/Seasons.vue